import { render } from "./FlashMessages.vue?vue&type=template&id=38c7cb32&scoped=true"
import script from "./FlashMessages.vue?vue&type=script&lang=js"
export * from "./FlashMessages.vue?vue&type=script&lang=js"

import "./FlashMessages.vue?vue&type=style&index=0&id=38c7cb32&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38c7cb32"]])

export default __exports__